import { c as _c } from "react/compiler-runtime";
import { cn } from "@dc/ui/lib/utils";
import type { FC, ReactNode } from "react";
import { Button } from "../Button";
import { Chip } from "../Chip";
import type { FilterChip } from "./types";
export interface FiltersToolbarProps {
  chips?: FilterChip[];
  onClearAll?: () => void;
  clearAllLabel?: string;
  className?: string;
  trailingContent?: ReactNode;
}
const FiltersToolbar: FC<FiltersToolbarProps> = t0 => {
  const $ = _c(17);
  const {
    chips: t1,
    onClearAll,
    clearAllLabel: t2,
    className: t3,
    trailingContent
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const chips = t4;
  const clearAllLabel = t2 === undefined ? "Clear all" : t2;
  const className = t3 === undefined ? "" : t3;
  let t5;
  if ($[2] !== className) {
    t5 = cn("flex flex-wrap items-center gap-2", className);
    $[2] = className;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== chips) {
    t6 = chips.length > 0 && chips.map(_temp);
    $[4] = chips;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== chips.length || $[7] !== clearAllLabel || $[8] !== onClearAll) {
    t7 = onClearAll && chips.length > 0 && <Button size="sm" variant="light" color="primary" onPress={onClearAll}>{clearAllLabel}</Button>;
    $[6] = chips.length;
    $[7] = clearAllLabel;
    $[8] = onClearAll;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="flex flex-wrap items-center gap-2">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8 || $[15] !== trailingContent) {
    t9 = <div className={t5}>{t8}{trailingContent}</div>;
    $[13] = t5;
    $[14] = t8;
    $[15] = trailingContent;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default FiltersToolbar;
function _temp(chip) {
  return <Chip key={chip.key} variant="bordered" onClose={chip.onClose} data-testid="filter-chip"><span className="flex items-center gap-1"><span className="font-semibold">{chip.label}:</span><span>{chip.content}</span></span></Chip>;
}